import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import AppViewSheetBreadcrumb from "@/v2-backoffice-client/app/AppViewSheetBreadcrumb"
import Tabs from "@/v2-backoffice-client/components/tabs"
import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"
import { useAddOnCatalogQuery } from "@/v2-backoffice-client/license/addOns/catalog/license.addOn.catalog.query"
import LicenseAddOnViewInfo from "@/v2-backoffice-client/license/addOns/catalog/view/LicenseAddOnViewInfo"
import LicenseAddOnViewToolbar from "@/v2-backoffice-client/license/addOns/catalog/view/LicenseAddOnViewToolbar"
import LicenseAddOnFeatureGroupsTab from "@/v2-backoffice-client/license/addOns/catalog/view/LicenseAddOnFeatureGroupsTab"
import LicenseAddOnGrantsTable from "@/v2-backoffice-client/license/addOns/catalog/view/LicenseAddOnGrantsTable"

// The add-on panel (?v=addOn:<id>). Fed by the same getAddOnCatalog list the
// board renders, so board→panel opens from the Apollo cache. Two tabs, the
// two things an add-on is made of: Packages, what a customer gets on top of
// their license (the row already carries the membership, so the tab edits
// with no extra read); Customers, who has it, with the license that carries
// it for each. Which license the add-on goes with is in the header and
// edited with the add-on itself (Edit).
function LicenseAddOnViewSheet() {
  const { id } = useAppViewSheetOpener()
  const addOnId = Number(id)

  const { data, previousData, loading, error, refetch } = useAddOnCatalogQuery({
    skip: !addOnId,
  })
  // previousData keeps the panel rendered through post-save evictions,
  // when the cache is briefly empty and data undefined.
  const addOns = (data ?? previousData)?.getAddOnCatalog ?? []
  const addOn = addOns.find((candidate) => candidate.Id === addOnId)

  return (
    <>
      <ViewSheet.Header>
        <AppViewSheetBreadcrumb />
        <ViewSheet.Title isLoading={loading && !addOn}>
          {addOn?.Name}
        </ViewSheet.Title>
      </ViewSheet.Header>

      <ViewSheet.HeaderRow>
        <LicenseAddOnViewInfo addOn={addOn} isLoading={loading && !addOn} />
        <LicenseAddOnViewToolbar addOn={addOn} />
      </ViewSheet.HeaderRow>

      <Tabs
        id="license-add-on-view-tabs"
        defaultValue="featureGroups"
        // Only gate the tabs while there is nothing to show — see the license
        // sheet: gating on every cache-and-network revalidation would
        // unmount and flash the whole panel.
        isLoading={loading && !addOn}
        error={error}
        isEmpty={!loading && !addOn}
        emptyLabel="Add-on not found."
      >
        <Tabs.List>
          <Tabs.Trigger
            value="featureGroups"
            count={addOn?.FeatureGroups.length}
          >
            Packages
          </Tabs.Trigger>
          <Tabs.Trigger value="customers" count={addOn?.GrantCount}>
            Customers
          </Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="featureGroups" className="min-h-0 flex-1">
          {addOn && <LicenseAddOnFeatureGroupsTab addOn={addOn} />}
        </Tabs.Content>

        <Tabs.Content value="customers" className="min-h-0">
          {addOn && (
            <LicenseAddOnGrantsTable
              addOnId={addOn.Id}
              addOnName={addOn.Name}
              onRefresh={() => void refetch()}
            />
          )}
        </Tabs.Content>
      </Tabs>
    </>
  )
}

export default LicenseAddOnViewSheet
